import { render } from "./reports-header.vue?vue&type=template&id=23a8ef6e"
import script from "./reports-header.vue?vue&type=script&lang=js"
export * from "./reports-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__